import React, { useState } from 'react';
import { SearchIcon } from '../icons';

const SearchInput = ({ 
  placeholder = "Search...", 
  value, 
  onChange, 
  onFocus, 
  onBlur, 
  className = "",
  disabled = false,
  ...props 
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [internalValue, setInternalValue] = useState('');

  const handleFocus = (e) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (value !== undefined) {
      onChange?.(e);
    } else {
      setInternalValue(newValue);
    }
  };

  const currentValue = value !== undefined ? value : internalValue;

  return (
    <div 
      className={`relative inline-flex items-center w-55 h-10 rounded-xl border transition-all duration-200 ${
        isFocused 
          ? 'border-[#ECECEC] dark:border-[#202020] shadow-sm' 
          : 'border-[#ECECEC] dark:border-[#202020]'
      } ${
        disabled 
          ? 'bg-[#F7F7F7] dark:bg-[#252525] cursor-not-allowed' 
          : 'bg-[#F7F7F7] dark:bg-[#252525] hover:bg-[#F1F1F1] dark:hover:bg-[#2A2A2A]'
      } ${className}`}
    >
      {/* Search Icon */}
      <div className="flex items-center justify-center w-8 h-8 ml-1">
        <SearchIcon 
          size={16} 
          className="text-[#7B7B7B] dark:text-[#848484]"
        />
      </div>

      {/* Input Field */}
      <input
        type="text"
        value={currentValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        className={`flex-1 px-3 py-2 bg-transparent text-sm font-medium placeholder-[#7B7B7B] dark:placeholder-[#848484] text-[#121212] dark:text-[#D0D0D0] focus:outline-none ${
          disabled ? 'cursor-not-allowed' : ''
        }`}
        {...props}
      />
    </div>
  );
};

export default SearchInput;



